<!-- eslint-disable vue/no-mutating-props -->
<script setup lang="ts">
import type { SiteBlock } from '../../../types/site'

defineProps<{ block: SiteBlock }>()

const t = useSiteEditorT()
</script>

<template>
  <!-- eslint-disable vue/no-mutating-props -->
  <UFormField :label="t('site.f.two_column.left_title', 'Left title')">
    <UInput
      v-model="block.data.left_title"
      class="w-full"
    />
  </UFormField>
  <UFormField :label="t('site.f.two_column.left_content', 'Left content')">
    <SiteEditorRichTextField
      :model-value="block.data.left_html"
      @update:model-value="block.data.left_html = $event"
    />
  </UFormField>
  <UFormField :label="t('site.f.two_column.right_title', 'Right title')">
    <UInput
      v-model="block.data.right_title"
      class="w-full"
    />
  </UFormField>
  <UFormField :label="t('site.f.two_column.right_content', 'Right content')">
    <SiteEditorRichTextField
      :model-value="block.data.right_html"
      @update:model-value="block.data.right_html = $event"
    />
  </UFormField>
</template>
